import MemberAvatar from './MemberAvatar';

export default MemberAvatar;
